import { render } from "./Repositories.vue?vue&type=template&id=7b1c9de0"
import script from "./Repositories.vue?vue&type=script&lang=ts"
export * from "./Repositories.vue?vue&type=script&lang=ts"

import "./Repositories.vue?vue&type=style&index=0&id=7b1c9de0&lang=scss"
script.render = render

export default script